"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialIcon = void 0;

var _socialIcon = _interopRequireDefault(require("./social-icon.js"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var SocialIcon = _socialIcon.default;
exports.SocialIcon = SocialIcon;